module.exports = __webpack_public_path__ + "assets/065438c98de2b7f979decf5d7e3eb8a0.woff2";


//////////////////
// WEBPACK FOOTER
// ../~/@fontsource/roboto/files/roboto-latin-ext-300-normal.woff2
// module id = 2638
// module chunks = 121